import React from "react";
import { IconButton as MuiIconButton } from "@mui/material";

const IconButton = React.forwardRef(function IconButton(props, ref) {
  const { href, target, rel, color, ...others } = props;
  return (
    <MuiIconButton
      href={href}
      target={target || "_blank"}
      rel={rel || "noopener noreferrer"}
      {...others}
      ref={ref}
    />
  );
});

export default IconButton;
